import axios from "axios";
import { logout } from "../redux/actions";
import store from "../store";

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    Accept: "application/json, text/plain, */*",
    "Content-Type": "application/json; charset=utf-8",
    "Access-Control-Allow-Origin": "*",
  },
});

// Interceptor để xử lý trước khi yêu cầu được gửi đi
instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("accessToken");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    console.log("test dbhwah738912y39821");
    return Promise.reject(error);
  },
);

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  failedQueue = [];
};

// Hàm kiểm tra API có phải là login hoặc refresh không
const isAuthApi = (url) => {
  return url.includes("/auth/login") || url.includes("/auth/refresh");
};

instance.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const originalRequest = error.config;

    // Nếu là API login hoặc refresh thì không tự động refresh token
    if (isAuthApi(originalRequest.url)) {
      console.log("Auth API detected, skipping refresh logic");
      return Promise.reject(error);
    }

    // Handle 401 errors - both from response status and network errors
    const is401Error = error.response?.status === 401;

    if (is401Error && !originalRequest._retry) {
      console.log("=== 401 ERROR DETECTED ===");
      console.log("Error response:", error.response);
      console.log("Error code:", error.code);
      console.log("Error message:", error.message);
      console.log("Original request:", originalRequest);
      console.log("Is retry:", originalRequest._retry);

      // Kiểm tra xem có refresh token không
      const refreshToken = localStorage.getItem("refreshToken");
      console.log("Refresh token exists:", !!refreshToken);

      // Nếu không có refresh token, logout ngay lập tức
      if (!refreshToken) {
        localStorage.removeItem("accessToken");
        localStorage.removeItem("refreshToken");
        localStorage.removeItem("user");
        store.dispatch(logout());
        window.dispatchEvent(new Event("force-logout"));
        return Promise.reject(error);
      }

      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        })
          .then((token) => {
            originalRequest.headers.Authorization = `Bearer ${token}`;
            return instance(originalRequest);
          })
          .catch((err) => Promise.reject(err));
      }

      originalRequest._retry = true;
      isRefreshing = true;
      console.log("Starting token refresh process...");

      try {
        const response = await instance.post("/auth/refresh", {
          refreshToken: refreshToken,
        });

        const { token } = response.data;
        localStorage.setItem("accessToken", token);

        instance.defaults.headers.common.Authorization = `Bearer ${token}`;
        originalRequest.headers.Authorization = `Bearer ${token}`;

        processQueue(null, token);

        return instance(originalRequest);
      } catch (refreshError) {
        processQueue(refreshError, null);
        // Clear localStorage
        localStorage.removeItem("accessToken");
        localStorage.removeItem("refreshToken");
        localStorage.removeItem("user");
        // Clear Redux state by dispatching logout action
        store.dispatch(logout());
        // Trigger force logout event for UI update
        window.dispatchEvent(new Event("force-logout"));
        return Promise.reject(refreshError);
      } finally {
        isRefreshing = false;
        console.log("Refresh process completed");
      }
    }

    // Xử lý tất cả các lỗi 401 khác (không phải do token hết hạn)
    const is401ErrorAfterRetry =
      error.response?.status === 401 ||
      (error.code === "ERR_NETWORK" && error.message === "Network Error");

    if (is401ErrorAfterRetry && originalRequest._retry) {
      // Nếu đã retry rồi mà vẫn 401, có nghĩa là refresh token cũng không hợp lệ
      localStorage.removeItem("accessToken");
      localStorage.removeItem("refreshToken");
      localStorage.removeItem("user");
      store.dispatch(logout());
      window.dispatchEvent(new Event("force-logout"));
      return Promise.reject(error);
    }

    if (error.response) {
      console.error("Response error:", error.response);
    } else if (error.request) {
      console.error("Request error:", error.request);
    } else {
      console.error("Error:", error.message);
    }
    return Promise.reject(error);
  },
);

export default function requestApi(
  endpoint,
  method,
  body,
  responseType = "json",
) {
  const config = {
    method: method,
    url: endpoint,
    data: body,
    responseType: responseType,
  };

  // Tự động set Content-Type cho FormData
  if (body instanceof FormData) {
    config.headers = {
      ...config.headers,
      "Content-Type": "multipart/form-data",
    };
  }

  return instance.request(config);
}
